module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/cognito-sync-2014-06-30.paginators.json
// module id = 157
// module chunks = 1